const fit = (state) => state.fit;

export default fit;
